import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "card-title inter-500 linear-gradient-black-to-green-2" }
const _hoisted_2 = { class: "card-subtitle source-code-pro-300" }
const _hoisted_3 = { class: "source-code-pro-400" }

import { Experience } from '@/interfaces/experience.interface';
import { ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BaseCard',
  props: {
    value: {}
  },
  setup(__props: any) {


const props = __props
    const items = ref(props.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, ({title, date, activities}, i) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "card",
      key: i
    }, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(title), 1),
      _createElementVNode("h3", _hoisted_2, _toDisplayString(date), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities, (activity, i) => {
        return (_openBlock(), _createElementBlock("ul", {
          class: "list",
          key: i
        }, [
          _createElementVNode("li", _hoisted_3, _toDisplayString(activity), 1)
        ]))
      }), 128))
    ]))
  }), 128))
}
}

})